export const HOURS_PER_WORK_MONTH = 160;

export const applyRoundingRules = (amount: number): number => {
    const roundedToThousand = Math.round(amount / 1000) * 1000;
    return roundedToThousand - 100;
};

export const formatCurrency = (amount: number, currency: string): string => {
    const locale = currency === 'PLN' ? 'pl-PL' : 'en-US';

    return new Intl.NumberFormat(locale, {
        style: 'decimal',
        maximumFractionDigits: 0,
        useGrouping: true,
    }).format(amount);
};

export const calculateTranchesCount = (durationMonths: number): number => {
    const workTranches = Math.ceil(durationMonths / 3);
    return Math.max(2, workTranches + 1);
};

export const calculateMilestonesCount = (trancheCount: number): number => {
    return trancheCount - 1;
};
